<div class="hero">
  <div class="hero__row">
    <button
      mat-stroked-button
      type="button"
      class="hero__filter"
      [class.hero__filter--active]="filtersActive()"
      (click)="openFilters()"
      aria-label="Filter profiles"
    >
      <mat-icon>filter_list</mat-icon>
      Filter
    </button>

    <div class="hero__widgets">
      <div
        class="active-meter"
        aria-live="polite"
        aria-label="Simulated active users count"
        title="A very accurate count of active users"
      >
        <div class="active-meter__top">
          <span class="active-meter__label">Active Users</span>
          <span class="active-meter__live" aria-hidden="true"></span>
        </div>
        <div class="active-meter__value">{{ activeUsers() | number }}</div>
        <div class="active-meter__track" role="presentation">
          <div class="active-meter__fill" [style.width.%]="activeUsersMeterFill()"></div>
        </div>
      </div>

      <div
        class="active-meter active-meter--gages"
        aria-label="Active Gages: 1"
        title="The one and only"
      >
        <div class="active-meter__top">
          <span class="active-meter__label active-meter__label--gages">Active Gages</span>
          <span class="active-meter__pin" aria-hidden="true"></span>
        </div>
        <div class="active-meter__value">1</div>
        <div class="active-meter__track" role="presentation">
          <div class="active-meter__fill active-meter__fill--gages"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="profiles() as p; else loading">
  <div class="swipe-stack-bleed" *ngIf="p.length > 0">
    <app-swipe-deck
      [profiles]="p"
      (swipeRight)="onSwipeRight($event)"
      (swipeLeft)="onSwipeLeft($event)"
      (superLike)="onSuperLike($event)"
    />
  </div>

  <div class="empty" *ngIf="p.length === 0">
    <h2>You're out of profiles.</h2>
    <p>Go touch grass, then refresh for the exact same people.</p>
    <button mat-raised-button color="primary" (click)="refresh()">Refresh</button>
  </div>
</ng-container>

<ng-template #loading>
  <div class="loading">
    <div class="pulse"></div>
    <div class="pulse"></div>
    <div class="pulse"></div>
    <p>Loading your next match...</p>
  </div>
</ng-template>

